<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-family: '微软雅黑';
}
body{
  margin: 0;
  padding: 0;
}
ul{
  margin: 0;
  padding: 0;
  list-style: none;
}
.close-win-text-info p{
  margin: 6px 0!important;
  line-height: 20px;
}

@media screen and (max-width: 640px){
  .close-win-text-info p{
    margin: 2px 0!important;
    line-height: 17px;
  }
}
</style>
